import { SkipIcon, NextIcon, PrevIcon, Upload } from "images";

export const IconNames = {
  Skip: SkipIcon,
  Next: NextIcon,
  Previous: PrevIcon,
  Upload: Upload,
};
